<template>
<div class="chapter">
<div class="inner_page">
<p class="IVPh1" id="toc">Creating a Missional Culture</p>
<p class="IVPh3">Equipping the Church for the Sake of the World</p>
<p class="first"> </p>
<p class="IVPh3">JR Woodward</p>
<p class="IVPh3">Forword by Alan Hirsch</p>
<p class="first"> </p>
<p class="IVPcenter"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></p>
<p class="IVPcenter"><a href="http://www.IVPress.com/books/" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?130404b7